import { getAframeFont } from 'components/AFrame/utils/fontHelpers';
import React from 'react';

const AframeTitle = ({
  id,
  title,
  forwardRef,
  darkMode,
  iconSize,
  fontWeight = 'bold',
  fontName = 'roboto',
  ...rest
}) => {
  const height = iconSize?.size || 1;
  const scaleOffset = (4 - height) * 0.25;
  const position = `0 ${(height + scaleOffset) / 2} 0`;
  const { font, fontImage } = getAframeFont({ fontName, fontWeight });
  return (
    <a-text
      ref={forwardRef}
      scale="1 1 1"
      id={id}
      height="0.1"
      width="10"
      visible="false"
      align="center"
      value={title}
      position={position}
      opacity="1"
      material="transparent: false; depthWrite: true;"
      color={`${darkMode ? '#000' : '#fff'}`}
      font={font}
      font-image={fontImage}
      negate="false"
      shader="msdf"
      {...rest}
    />
  );
};

export default AframeTitle;
